module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAUBJREFUaEPtmD1qAlEUhc8d87MOCQGn04gMKWcRFunjBtLHHaQz4Cayj0yhhYVCsHAJSZEfkuALgkUMEYRzn/LgTD33vne+7/0MY0j8scTnDwU4tEEZkAGSgJYQCZAulwEaIdlABkiAdLkM0AjJBjJAAqTLZeA/hNV4doclepZh8Npq9Euzbxr1lgZRDFSj6RdgR+sxH5cZri5b+SJGiEgBZmFzsuE5M7vuXOQP3iH2FAAwsxCA4dvL6U1Z1j+8guwtwK8JT1A76RbNsyePEIcIsJr3vGjn5woAxPmtUo3+buIN1hPU0C2aeVpLKPFNnN4x+gngON2LbPUpEdALAffv7cZtcp8SHsfjrj2i3AO7Du7xngJ4UGR6yABDz6NWBjwoMj1kgKHnUSsDHhSZHjLA0POolQEPikwPGWDoedT+AFndWDELarCJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/imgs/land22.png
// module id = RfP+
// module chunks = 0